import apiServices from './apiServices'

export default class extends apiServices {
  // Charge les infos générales liées à la reservation
  static loadSummary (campingId) {
    return this.get('/api/booking/summary/' + campingId, null)
  }

  // Charge les infos d'assurance
  static loadDocuments (campingId) {
    return this.get('/api/booking/documents/' + campingId, null)
  }

  // teste la validité d'une url d'assurance annulation
  static checkDocumentUrl (url) {
    return this.post('/api/booking/documents/checkUrl?url=' + url, null)
  }

  // modifier le lien d'un document d'assurance annulation ou cg
  static updateDocumentUrl (campingId, assu) {
    return this.post('/api/booking/documents/' + campingId + '/update', assu)
  }

  // charger les resas pour une saison
  static loadBookings (campingId, year) {
    return this.get('/api/booking/list/' + campingId + '/' + year)
  }

  // charger les resas pour une saison sous forme de document
  static loadBookingsReport (year, campingId) {
    return this.download('/api/booking/report/' + year + (campingId !== null ? ('?campingId=' + campingId) : ''))
  }

  // charge les infos de paiement d'une resa
  static loadBookingPayment (bookingId) {
    return this.get('/api/booking/' + bookingId + '/payment')
  }
}
